export enum PermissionType {
  Confirm = 'confirm',
  Decline = 'decline',
}
